module.exports = __webpack_public_path__ + "media/images/content_marketing_dollar-efe1b2c836da8b44156ef5a0818df50c.svg";